import { Box, Flex, Text } from '@chakra-ui/react'
import { AUTH_DIVIDER_COLOR, authMutedColor } from 'components/Layouts/AuthLayout/constants'

interface AuthOrDividerProps {
  label?: string
}

/** Separator: line — or — line, centered so the label sits on the optical axis of the form. */
const AuthOrDivider = ({ label = 'or' }: AuthOrDividerProps) => (
  <Flex
    align="center"
    w="100%"
    gap={3}
    role="separator"
    aria-label={`${label}, continue with another option`}
  >
    <Box flex={1} minW={0} h="1px" bg={AUTH_DIVIDER_COLOR} />
    <Text
      as="span"
      flexShrink={0}
      color={authMutedColor}
      fontSize="sm"
      fontWeight="400"
      lineHeight="1"
      m={0}
    >
      {label}
    </Text>
    <Box flex={1} minW={0} h="1px" bg={AUTH_DIVIDER_COLOR} />
  </Flex>
)

export default AuthOrDivider
